import { render, staticRenderFns } from "./CustomerCreateUpdate.vue?vue&type=template&id=8ce727d4&"
import script from "./CustomerCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreateUpdate.vue?vue&type=style&index=0&id=8ce727d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports